import { getDialogHooks } from 'utilities/dialog-context/dialog-context-helpers';
import MemberStatusChangeRequestDialog, {
  MemberStatusChangeRequestCallbackInput,
  MemberStatusChangeRequestDialogUniqueProps,
} from '../member-status-change-request-dialog';

const { useDialogForContext, useDialog: useMemberStatusChangeRequestDialog } =
  getDialogHooks<
    MemberStatusChangeRequestDialogUniqueProps,
    MemberStatusChangeRequestCallbackInput
  >(MemberStatusChangeRequestDialog);
export const useMemberStatusChangeRequestDialogForContext = useDialogForContext;
export default useMemberStatusChangeRequestDialog;
